import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { api } from '../api/sre'

export const fetchSreEvents = createAsyncThunk(
  'sre/fetchEvents',
  ({ application, start, end }) => api.getSreEvents(application, { start, end })
)

export const deleteSreEvent = createAsyncThunk(
  'sre/deleteEvent',
  ({ application, sreTimestamp }) => api.deleteSreEvent(application, sreTimestamp).then(() => sreTimestamp)
)

const sreSlice = createSlice({
  name: 'sre',
  initialState: {
    application: 'stock-price-lambda',
    start: null,
    end: null,
    events: [],
    hasMore: false,
    loading: false,
    error: null,
    deleteError: null,
    statusFilter: 'all',
    sortColumn: 'sre_timestamp',
    sortDirection: 'desc',
  },
  reducers: {
    setApplication(state, action) {
      state.application = action.payload
    },
    setDateRange(state, action) {
      state.start = action.payload.start
      state.end = action.payload.end
    },
    setStatusFilter(state, action) {
      state.statusFilter = action.payload
    },
    setSort(state, action) {
      const column = action.payload
      if (state.sortColumn === column) {
        state.sortDirection = state.sortDirection === 'desc' ? 'asc' : 'desc'
      } else {
        state.sortColumn = column
        state.sortDirection = 'desc'
      }
    },
    resetFilters(state) {
      state.application = 'stock-price-lambda'
      state.start = null
      state.end = null
      state.statusFilter = 'all'
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSreEvents.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSreEvents.fulfilled, (state, action) => {
        state.loading = false
        state.events = action.payload.events
        state.hasMore = action.payload.has_more
        state.sortColumn = 'sre_timestamp'
        state.sortDirection = 'desc'
      })
      .addCase(fetchSreEvents.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
      .addCase(deleteSreEvent.pending, (state) => {
        state.deleteError = null
      })
      .addCase(deleteSreEvent.fulfilled, (state, action) => {
        state.events = state.events.filter((e) => e.sre_timestamp !== action.payload)
      })
      .addCase(deleteSreEvent.rejected, (state, action) => {
        state.deleteError = action.error.message
      })
  },
})

export const { setApplication, setDateRange, setStatusFilter, setSort, resetFilters } = sreSlice.actions
export default sreSlice.reducer
